// Arkadaşını Getir: davet linki ve davet kodunun tarayıcıda hatırlanması.
// Davet linki (/register?davet=YES-XXXXX) açıldığında kod saklanır: kişi o an kayıt olmasa ya da zaten
// hesabı olduğu için giriş yapsa bile ödeme sayfasında kod hazır gelir.

const STORAGE_KEY = "yes_referral_code";

export function rememberReferralCode(code: string): void {
  try {
    if (code) window.localStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* gizli pencere vb. — kod yine URL'den okunur */
  }
}

export function readRememberedReferralCode(): string {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function buildInviteLink(code: string): string {
  return `${window.location.origin}/register?davet=${encodeURIComponent(code)}`;
}

export function buildWhatsAppShareUrl(text: string): string {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}
